module.exports = "a";


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/async/loaders/syncloader.js!./loaders/async/loaders/asyncloader.js!./loaders/async/a.js
 ** module id = 5
 ** module chunks = 0
 **/